import type { OneColumnLayoutProps } from '../../../../../../node_modules/@dip/helsecore/src/components/layouts/OneColumn/OneColumn.d';

import {
	type MetaData,
	type LayoutData,
	Region,
} from '@enonic/react-components';
import React from 'react';
import {
	Container,
	regionCn,
} from '@dip/helsecore/src/components/layouts/OneColumn/OneColumn';


const TRACE = false;


export function OneColumn(props: {
	common?: Record<string, unknown>;
	component: LayoutData;
	data: OneColumnLayoutProps;
	meta: MetaData;
}): JSX.Element {
	if (TRACE) console.debug('OneColumnLayout props', JSON.stringify(props, null, 4));
	const { component, data, meta } = props;
	const {
		backgroundColor,
		marginSelection,
		// names,
		// regionsData,
		gapSelection,
		maxWidth,
	} = data;
	return (
		<Container backgroundColor={backgroundColor} marginSelection={marginSelection}>
			<Region
				// NOTE: I don't think xp-region is needed here:
				className={regionCn({
					gapSelection,
					maxWidth,
				})}
				data={component.regions.main.components}
				meta={meta}
				name="main"
			/>
		</Container>
	);
}
